<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> FAQ知识库后台
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.name" placeholder="游戏名称" style="width:200px;"></el-input>
          <el-button
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleFilter"
          >搜索</el-button>
        <el-button
                class="filter-item"
                style="margin-left: 10px;"
                type="primary"
                icon="el-icon-edit"
                @click="handleCreate"
        >添加</el-button>

        </div>

        <el-table border v-loading="listLoading" min-height="200"  max-height="1000"  :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="ID"/>
            <el-table-column prop="account" label="账号"/>
            <el-table-column prop="title" label="验证信息"/>
            <el-table-column prop="type_name" label="类型"/>
            <el-table-column label="操作" align="center" width="260" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                            type="primary"
                            style="margin-right: 10px;"
                            size="mini"
                            @click="handleUpdate(scope.row)"
                    >修改</el-button>
                    <el-popover placement="top" width="160" v-model="scope.row.deleteVisible">
                        <p>确定删除吗?</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="handleDelete(scope.row)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="danger">删除</el-button>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleList"
        />
        <el-dialog title="工单统计" width="60%"  center :visible.sync="dialogFormVisible" >
              <el-form :model="formData" style="margin-left:50px;">
                  <el-form-item label="ID" :label-width="formLabelWidth" v-if="formData.id != ''">
                      <el-col :span="8">
                          <el-input v-model="formData.id" :disabled="idDisabled"></el-input>
                      </el-col>
                  </el-form-item>
                  <el-form-item label="账号" :label-width="formLabelWidth">
                      <el-col :span="8">
                          <el-input v-model="formData.account"></el-input>
                      </el-col>
                  </el-form-item>
                  <el-form-item label="验证信息" :label-width="formLabelWidth">
                      <el-col :span="8">
                          <el-input v-model="formData.title"></el-input>
                      </el-col>
                  </el-form-item>
                  <el-form-item label="类型" :label-width="formLabelWidth">
                      <el-col :span="8">
                          <el-select v-model="formData.type" filterable  placeholder="类型">
                              <el-option
                                      v-for="item in typeData"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                              </el-option>
                          </el-select>
                      </el-col>
                  </el-form-item>

              </el-form>
              <div slot="footer" class="dialog-footer">
                  <el-button @click="handleResetForm">取 消</el-button>
                  <el-button type="primary" @click="handleCreateUpdateStore">确 定</el-button>
              </div>
          </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
    handleListApi,
    handleCreateStoreApi,
    handleDeleteApi
} from "@/api/work_kefu.js";
import Pagination from "@/components/pagination/index";
    export default {
        components: { Pagination },
        data() {
        return {
            typeData:[{'id':1, 'name':'QQ'},{'id':2, 'name':'微信'},{'id':3, 'name':'手机'},{'id':4, 'name':'电话'}],
            // 列表
            listLoading: false,
            total: 0,
            tableData: [],
            listQuery: {
                page: 1,
                limit: 10,
                work_sn:undefined
            },
            // 表单
            dialogFormVisible: false,
            idDisabled: true,
            formData: {
                id: "",
                account: "",
                title: "",
                type: ""
            },
            formLabelWidth: "120px",
        };
    },
    created() {
        this.handleList(this.listQuery);
    },
    methods: {
        handleList() {
            this.listLoading = true;
            handleListApi(this.listQuery)
            .then(response => {
                const data = response.data.data;
                this.tableData = data;
                this.total = response.data.total;
                setTimeout(() => {
                    this.listLoading = false;
                }, 0.5 * 1000);
            })
            .catch(error => {
                this.listLoading = false;
                console.log(error);
            });
        },
        handleCreate() {
            this.handleResetForm();
            this.dialogFormVisible = true;
        },
        handleUpdate(row) {
            this.dialogFormVisible = true;
            this.formData.id = row.id;
            this.formData.account = row.account;
            this.formData.title = row.title;
            this.formData.status = row.status;
            this.formData.type = row.type;
            handleLogDataApi({'id':row.id})
                .then(response => {
                    const data = response.data.data;
                    this.tableData = data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleDelete(row) {
            handleDeleteApi(row)
                .then(response => {
                    this.$message.success("操作成功");
                    row.deleteVisible = false;
                    this.handleList(this.listQuery);
                })
                .catch(error => {});
        },
        handleResetForm() {
            this.formData.id = "";
            this.formData.title = "";
            this.formData.account = "";
            this.formData.type = "";
            this.dialogFormVisible = false;
        },
        handleCreateUpdateStore() {
            handleCreateStoreApi(this.formData)
            .then(response => {
                this.$message.success("操作成功");
                this.dialogFormVisible = false;
                this.handleList(this.listQuery);
            })
            .catch(error => {
              console.log(error);
            });
        },
        handleFilter() {
            this.handleList(this.listQuery);
        },
    }
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
